export interface AttributeReviewFilterSession {
  marketplace?: string | null;
  productType?: string | null;
  needReviewFields?: number | null;
  status?: string | null;
}

// Mirrors the server's REVIEW_VISIBLE_SESSION_STATUSES. A failed approval sync
// must stay reachable (even at 0 need-review) so the reviewer can see it.
// ponytail: waits for an engine "finished" flag on the session. Intent: review list filter. Breaks if statuses are renamed.
const REVIEW_VISIBLE_SESSION_STATUSES = new Set([
  "NEEDS_APPROVAL",
  "APPROVAL_SYNC_FAILED",
]);

function normalizeMarketplaceValue(
  value: string | null | undefined,
): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed.toUpperCase() : null;
}

export function shouldKeepSessionInReviewFilter(
  session: AttributeReviewFilterSession,
  selected: {
    marketplace?: string | null;
    productType?: string | null;
  } = {},
): boolean {
  if ((session.needReviewFields ?? 0) > 0) return true;
  if (
    REVIEW_VISIBLE_SESSION_STATUSES.has(
      String(session.status ?? "")
        .trim()
        .toUpperCase(),
    )
  ) {
    return true;
  }

  const selectedProductType = selected.productType?.trim();
  if (!selectedProductType || session.productType !== selectedProductType) {
    return false;
  }

  const selectedMarketplace = normalizeMarketplaceValue(selected.marketplace);
  if (!selectedMarketplace) return true;
  return normalizeMarketplaceValue(session.marketplace) === selectedMarketplace;
}
